import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { Box } from '../box';
import { useSlot } from './hooks';
import { useColor } from '../../hooks';
import styles from './styles.module.css';
export const Text = memo(forwardRef(function Text({ children, align = 'left', reverse, size, color = 'main', ...props }, ref) {
    const { context } = useSlot({ size });
    const colorClass = useColor(color);
    return (React.createElement(Box, { ref: ref, ...props, className: cn(colorClass, styles.text, styles[size || context.size], styles[align], props.className, {
            [styles.noTrailingPadding]: !!context.noTrailingPadding,
        }), flexDirection: reverse ? 'column-reverse' : 'column' }, children));
}));
